module.exports = __webpack_public_path__ + "static/media/product-onogate-detail.b0236ed6.png";